var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contenedor-cpanel"},[_c('section',{staticClass:"contenedor-c"},[_c('h1',[_vm._v("Stock")]),_c('StockLista')],1),_c('router-link',{attrs:{"to":"/movimiento-stock"}},[_vm._v("MOVIMIENTO STOCK")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }